import { useState } from "react";
import { Send } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface CommentFormProps {
  token: string;
  pilId: string;
  clientId: string;
  disabled?: boolean;
}

export function CommentForm({
  token,
  pilId,
  clientId,
  disabled,
}: CommentFormProps) {
  const [value, setValue] = useState("");
  const utils = trpc.useUtils();
  const addMut = trpc.cityReport.addComment.useMutation({
    onSuccess: () => {
      setValue("");
      utils.cityReport.listComments.invalidate({ token, pilId });
      utils.cityReport.getReport.invalidate({ token });
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    addMut.mutate({ token, pilId, comment: trimmed, clientId });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <Textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Add a comment..."
        rows={3}
        disabled={disabled || addMut.isPending}
      />
      <div className="flex items-center justify-between">
        <p className="text-xs text-muted-foreground">
          Comments are anonymous.
        </p>
        <Button
          type="submit"
          size="sm"
          disabled={disabled || addMut.isPending || value.trim().length === 0}
        >
          <Send className="size-4" />
          {addMut.isPending ? "Sending..." : "Post comment"}
        </Button>
      </div>
      {addMut.error && (
        <p className="text-xs text-destructive">{addMut.error.message}</p>
      )}
    </form>
  );
}
